// ProductModal.jsx
import React, { useContext, useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { MagnifierContainer, MagnifierPreview, MagnifierZoom } from 'react-image-magnifiers';
import ReactPlayer from 'react-player';
import { useDispatch, useSelector } from 'react-redux';
import './damPreviewModal.css';
import ModalContext from './ModalContext';
import noImage from '../../assets/images/no-image.png';
import Loader from '../Utility/Loader/Loader';
import * as systemMasterAction from '../../Pages/SystemMasters/Store/SystemMasters.action';

function DamPreviewModal() {
  const { isModalOpen, closeModal, modalData, setModalData, setDamDevOrderId } = useContext(ModalContext);
  const dispatch = useDispatch();
  const reducer = useSelector((reducerstate) => reducerstate);
  const [isLoading, setloading] = useState(true);
  const [imageUrl, setImageUrl] = useState('');
  const [playing, setPlaying] = useState(false);

  const {
    SystemMastersDetails: { subBrandAccess },
  } = reducer;

  useEffect(() => {
    return () => {
      setModalData(null);
      setDamDevOrderId(null);
    };
  }, [setModalData, setDamDevOrderId]);

  // Fetch sub-brand access on component mount
  useEffect(() => {
    dispatch(systemMasterAction.getSubBrandAccess());
  }, []);

  useEffect(() => {
    if (isLoading || modalData?.croppedImage || modalData?.imageUrl || modalData?.imageLink || modalData?.videoThumbnail || null) {
      setImageUrl(modalData?.croppedImage || modalData?.imageUrl || modalData?.imageLink || modalData?.videoThumbnail || null);
      setloading(false);
    } else {
      setImageUrl(null);
      setloading(false);
    }
  }, [modalData]);

  const handleImage = () => {
    setloading(false);
  };

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    // Clean up the overflow style when the component unmounts or modal state changes
    return () => {
      document.body.style.overflow = '';
    };
  }, [isModalOpen]);
  if (!isModalOpen) return null;

  return (
    isModalOpen && (
      <Card className="content-preview-modal">
        <Card.Header className="d-flex py-1 prewview-dam">
          <Card.Title className="f-24 font-heavy d-flex align-items-center justify-congtent-center mb-0">{modalData?.assetTitle}</Card.Title>
          <button type="submit" onClick={closeModal} aria-label="Close" className="px-0 btn ml-auto">
            <span className="icon icon-close" />
          </button>
        </Card.Header>
        <Card.Body className="dam-preview-body">
          {!modalData ? (
            <Loader />
          ) : (
            <>
              <div className="preview-section">
                {modalData?.videoLink || modalData?.videoUrl ? (
                  <ReactPlayer
                    light={modalData?.videoThumbnail}
                    className="react-player"
                    url={modalData?.videoLink || modalData?.videoUrl}
                    width="100%"
                    height={300}
                    controls
                    onClickPreview={() => setPlaying(true)}
                    playing={playing}
                  />
                ) : (
                  imageUrl && (
                    <MagnifierContainer>
                      <MagnifierPreview onImageLoad={handleImage} imageSrc={imageUrl} largeImageSrc={imageUrl} className="preview-image" />
                      <MagnifierZoom imageSrc={imageUrl} className="zoom-section" />
                    </MagnifierContainer>
                  )
                )}
                {!isLoading && imageUrl === null && <img src={noImage} alt="preview" className="img-fluid" />}
              </div>
              <div>
                <ul className="card-ul">
                  <li>
                    <div className="item-inline">
                      <p>
                        <strong>Assigned to: </strong>
                        {modalData?.assignedTo?.map((vl) => vl.number).join(', ')}
                      </p>
                      <p>
                        <strong>Size: </strong>
                        {`${modalData?.size} MB`}
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="item-inline">
                      <p>
                        <strong>Asset Type: </strong>
                        {modalData?.assetType}
                      </p>
                      <p>
                        <strong>Dimensions: </strong>
                        {modalData?.dimension}
                      </p>
                    </div>
                  </li>
                  <li>
                    <p className="mb-0">
                      <strong>Description: </strong>
                      {modalData?.description}
                    </p>
                  </li>

                  {modalData?.dynamicDropdown?.map((vl, idy) => {
                    return (
                      <li key={idy}>
                        <p className="mb-0">
                          <strong>{vl?.lableId?.keyName}: </strong>
                          {vl?.optionId?.keyName}
                        </p>
                      </li>
                    );
                  })}

                  {modalData?.dynamicText?.map((vl, idt) => {
                    return (
                      <li key={idt}>
                        <p className="mb-0">
                          <strong>{vl?.lableId?.keyName}: </strong>
                          {vl?.valueText}
                        </p>
                      </li>
                    );
                  })}
                </ul>
                <ul className="card-ul">
                  {modalData?.assignedTo?.map((products) => {
                    const { sizeRanges, number, brandId, catOneId, catTwoId, catThreeId, catFourId, gradingGroups, supplierType } = products;
                    const gradingValue = gradingGroups
                      ?.map((obj) => {
                        const filteredArr1 = obj?.sizeRanges?.filter((item) => sizeRanges?.includes(item?.name));
                        const sizeRangeNames = filteredArr1?.map((range) => range.name).join(',');
                        return `${obj.name} - ${sizeRangeNames}`;
                      })
                      ?.join(', ');
                    return (
                      <>
                        <li>
                          <strong>{number}</strong>
                        </li>
                        <li>
                          <div className="item-inline">
                            <p>
                              <strong>Product Type:</strong> {supplierType?.name}
                            </p>
                            <p>
                              <strong>Brand:</strong> {brandId?.name}
                            </p>
                          </div>
                        </li>
                        {subBrandAccess && (
                          <li>
                            <div className="item-inline">
                              <p>
                                <strong>Sub Brand:</strong> {products?.subBrandId?.name}
                              </p>
                            </div>
                          </li>
                        )}

                        <li>
                          <div className="item-inline">
                            <p>
                              <strong>Category 1: </strong> {catOneId?.name}
                            </p>
                            <p>
                              <strong>Category 2: </strong> {catTwoId?.name}
                            </p>
                          </div>
                        </li>
                        <li>
                          <div className="item-inline">
                            <p>
                              <strong>Category 3: </strong> {catThreeId?.name}
                            </p>
                            <p>
                              <strong>Category 4: </strong> {catFourId?.name}
                            </p>
                          </div>
                        </li>
                        <li>
                          <strong>Grading Group: </strong> {gradingValue}
                        </li>
                      </>
                    );
                  })}
                  <li>
                    <strong>Tags: </strong> {modalData?.tags?.map((vl) => vl.name).join(', ')}
                  </li>
                </ul>
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    )
  );
}

export default DamPreviewModal;
